module.exports = __webpack_public_path__ + "static/16-edcde9d13bf9380c51f96b5b23bd6f99.png";